import * as React from "react";
import { FrontCopyButton } from "../../../commonComponents/inline/frontCopyButton/frontCopyButton";
import { FontSlider } from "../../ynet1280/ynetHeader/components/mutamComponents/fontSliderComponent";
import * as throttle from "lodash/throttle"
const clickOutside = require('react-click-outside');

interface ArticleMutamHeaderNewShareState {
    isFontMenuOpen:boolean
    isDigitalMenuOpen:boolean
    isSticky: boolean
}

@clickOutside 
export class ArticleMutamHeaderNewShareComponent extends React.Component<{}, ArticleMutamHeaderNewShareState>{

    constructor(props) {
        super(props)
        this.state = {
            isFontMenuOpen: false,
            isDigitalMenuOpen: false,
            isSticky: false
        }
    }

    private ulRef: HTMLElement | null = null;
    private buttonRef: HTMLLIElement | null = null;
    private fontRef: HTMLLIElement | null = null;
    private FontRef: HTMLElement | null = null;


    private stickyBar() {
        let element = document.getElementById('calcalistArticleComponenta');
        const headerContainerPos = document.querySelector(".header-calcalist").getBoundingClientRect().top;
        const headerPos =  document.querySelector(".category-header-mutam").getBoundingClientRect().top;
        let isSticky =  element ? headerContainerPos + 40 < 0 : headerPos + 40 < 0;

        if (isSticky) {
            this.setState({ isSticky: true });
        } else {
            this.setState({ isSticky: false, isFontMenuOpen: false, isDigitalMenuOpen: false });
        }

        if (element) {
            let headerElRect = document.querySelector(".ArticleHeaderMobileComponent") && document.querySelector(".ArticleHeaderMobileComponent").getBoundingClientRect();
            if (!headerElRect) {
                return
            }
        }
    }

    componentDidMount() { 
        document.addEventListener("scroll", this.throttledScrollHandler())
        this.setfontSize();
        document.addEventListener("mousedown", this.handleClickOutside);
        document.addEventListener("touchstart", this.handleClickOutside);
    }

    componentWillUnmount() { 
        document.removeEventListener("scroll", this.throttledScrollHandler())
        document.removeEventListener("mousedown", this.handleClickOutside);
        document.removeEventListener("touchstart", this.handleClickOutside);
    }

    private throttledScrollHandler = () => throttle(() => this.stickyBar(), 200)



    private handleClickOutside = (event: MouseEvent | TouchEvent) => {
        const target = event.target as Node | null;
        if (this.ulRef && target && !this.ulRef.contains(target) && this.buttonRef && !this.buttonRef.contains(target)) {
           this.setState({ isDigitalMenuOpen: false  });
        }
        if (this.FontRef && target && !this.FontRef.contains(target) && this.fontRef && !this.fontRef.contains(target)) {
           this.setState({ isFontMenuOpen: false  });
        }
    }

    private setfontSize = () => {
        if (localStorage && localStorage.fontSize) {
            let size = localStorage.fontSize;
            document.documentElement.style.fontSize = size * parseInt(getComputedStyle(document.documentElement).fontSize) + "px";
        }

    }
 
    private handleFontSizePopupVisability =() =>{
            this.setState({ isFontMenuOpen: !this.state.isFontMenuOpen })         
    }

    private handleDigitalPopupVisability =(isDigitalMenuOpen) =>{
     this.setState(prev => ({ isDigitalMenuOpen: !prev.isDigitalMenuOpen }));
    }

    private handleCommentsPopupVisability = () => {
            if (typeof window !== "undefined") {
               window.handleCommentsPopupVisability && window.handleCommentsPopupVisability();        
            }
    }

     private showCommentsBtn = () => {
        return typeof window !== "undefined" && window.handleCommentsPopupVisability;

    }


    render() {
       const { isSticky, isFontMenuOpen, isDigitalMenuOpen } = this.state 
       const showDigital = isDigitalMenuOpen ? "opened" : ""; 
       const copy_url_link = typeof window === "undefined" ? "https://calcalist.co.il" : window.location.origin + window.location.pathname;
       const articleID = typeof window !== "undefined" && window.articleId && window.articleId;
       const is_Sticky = isSticky ? "" : "hidden";

        return (


        <div className={`sharingHeader ${is_Sticky}`} id="share-icons-wrapper">                 
            <ul className="art-action">
                <li ref={ref => this.fontRef = ref} className="share-icon icon-pf resize_font" onClick={this.handleFontSizePopupVisability} ></li>   
                 {isFontMenuOpen && <div className="FontContainer" ref={ref => this.FontRef = ref}><FontSlider  lang="he" /></div>}            
                <li style={{ display: this.showCommentsBtn() ? "block" : "none" }} className="share-icon topBtns commentsOpen" id="commentButtonInHeader" onClick={this.handleCommentsPopupVisability}></li>
                <FrontCopyButton
                        popupText="הקישור הועתק ללוח"
                        classes="share-icon copy"
                        url={`${copy_url_link}?utm_source="calcalist.co.il&utm_medium=Share&utm_campaign=copy_url#${articleID}`}
                />                
                <li ref={ref => this.buttonRef = ref} title="כלכליסט דיגיטל" className="share-icon digital" onClick={()=>this.handleDigitalPopupVisability(isDigitalMenuOpen)} />
                <li className="digitalText">כלכליסט דיגיטל </li>
                
                {isDigitalMenuOpen && 
                <div ref={ref => this.ulRef = ref} className={`digitalShare ${showDigital}`}>
                    <ul className="art-action-digital">
                        <li title="Facebook" className="share-icon facebook"><a href="https://www.facebook.com/calcalistonline" target="_blank"></a></li>
                        <li title="Twitter" className="share-icon twitter"><a href="https://x.com/calcalist" target="_blank"></a></li>
                        <li title="Telegram" className="share-icon telegram"><a href="  https://t.me/calcalist" target="_blank"></a></li>
                        <li title="Email" className="share-icon email"><a href="https://www.calcalist.co.il/newsletter"></a></li>
                        <li title="Podcast" className="share-icon podcast"><a href="https://www.calcalist.co.il/podcast"></a></li>
                        <li title="Tv" className="share-icon tv"><a href="https://www.calcalist.co.il/tv"></a></li>
                    </ul>
                </div>
                }          

              </ul>
             
              </div>               
       
        )

    }
}
